{
  "es": {
    "issue_list": {
      "actions": {
        "add_units": "Unidades",
        "all_units_assigned": "Todas las unidades asignadas",
        "change_responsible": "Cambiar responsable",
        "check": "Comprobar",
        "create_issue_lists": "Crear lista de incidencias | Crear listas de incidencias",
        "delete": "Eliminar",
        "delete_count": "Estás a punto de eliminar las incidencias de {count} unidad. ¿Estás seguro? | Estás a punto de eliminar las incidencias de {count} unidades. ¿Estás seguro?",
        "delete_issue_lists": "Eliminar incidencias",
        "edit": "Editar",
        "edit_issue_list": "Editar tipo de lista de incidencias",
        "export": "Exportar",
        "generatePDF": "Generar PDF",
        "go_to_summary": "Ir al resumen",
        "new": "Incidencia",
        "new_customer": "Notificar incidencia",
        "new_issue_list": "Lista de incidencias",
        "selectAll": "Seleccionar las {total} listas",
        "unSelectAll": "Limpiar selección",
        "update": "Actualizar"
      },
      "attributes": {
        "date": "Fecha de inicio",
        "description": "Descripción",
        "name": "Nombre"
      },
      "labels": {
        "aftercare_conversations": "Conversaciones de posventa",
        "aftercare_conversations_go_to_settings": "Ir a los ajustes",
        "aftercare_conversations_not_enabled": "Las conversaciones dentro de posventa todavía no están activadas. Puedes activarlas en los ajustes de tu organización.",
        "aftercare_conversations_toggle": "Activar conversaciones dentro de posventa",
        "assign_to_list": "Asignar a la lista",
        "collapse_all": "Contraer",
        "completed_header": "{completed_count} de {issues_count} incidencias completadas",
        "customer": "Cliente",
        "date": "Fecha de inicio (opcional)",
        "delete_explanation": "Todas las incidencias, junto con sus imágenes y documentos, se eliminarán de forma permanente de la plataforma.",
        "description_title": "Añade una descripción",
        "deselect_all": "Deseleccionar todo",
        "edit_multiple": "Editar {count} listas de incidencias",
        "hide_count": "Despublicar incidencias de 1 unidad | Despublicar incidencias de {count} unidades",
        "hide_count_SUP": "Despublicar incidencias",
        "issue_list": "Lista de incidencias",
        "issue_lists": "Posventa",
        "issue_lists_all_projects": "Posventa de todos los proyectos",
        "issues_count": "Incidencias",
        "no_issues_to_export": "No hay incidencias para exportar",
        "no_lists_completed": "No hay listas completadas",
        "open_all": "Expandir",
        "partners": "Colaboradores",
        "pdf_generated_successfully": "PDF generado correctamente",
        "process_issues": "Asignar a la lista",
        "project_units_total": "{project_name} tiene {units_count_max} unidades en total",
        "publish_now": "¿Publicar ahora?",
        "published_count": "Publicar incidencias de 1 unidad | Publicar incidencias de {count} unidades",
        "published_count_SUP": "Publicar incidencias",
        "save_explainer": "¿Quieres que las (futuras) incidencias sean visibles para tus clientes? ¿O prefieres guardarlas y publicarlas más tarde?",
        "selectOne": "Selecciona al menos 1 lista",
        "select_all": "Seleccionar todo",
        "selected": "{selected} lista seleccionada. | {selected} listas seleccionadas",
        "status": "estado",
        "step_1_info": "Por ejemplo, entrega provisional o definitiva, incidencias de la cocina o los baños...",
        "step_1_title": "¿Qué tipo de lista de incidencias quieres crear?",
        "step_2_subtitle": "Selecciona tu proyecto para incluir todas tus unidades a la vez. Siempre puedes añadir más unidades más tarde.",
        "step_2_title": "¿Para qué unidades quieres registrar incidencias?",
        "tab_issue_list_documents": "Documentos",
        "tab_issue_list_issues": "Incidencias",
        "tab_issue_list_issues_customer": "Posventa",
        "tab_issue_list_tickets": "Conversaciones",
        "tab_issues": "Todas las incidencias",
        "tab_units": "Unidades",
        "totalSelected": "Las {total} listas están seleccionadas",
        "you_have_customer_issues": "Tienes 1 incidencia de cliente sin procesar | Tienes {number} incidencias de cliente sin procesar"
      },
      "navigation": {
        "back_to_issue_lists": "Volver a las listas de incidencias"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Haz seguimiento de las incidencias notificadas",
            "title": "Aquí aparecerán todas tus incidencias"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Crea incidencias para las unidades vinculadas a la lista",
            "title": "Crea tu primera lista de incidencias"
          }
        },
        "partners": {
          "subtitle": "Te avisaremos cuando se creen nuevas incidencias",
          "title": "Todavía no tienes incidencias asignadas"
        }
      },
      "validation": {
        "name_taken_locale": "Este nombre ya se está usando en este idioma",
        "need_name": "El nombre es obligatorio"
      }
    }
  }
}
